import { Component, ViewChild, HostListener, inject } from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { shouldDrawerCloseOnEscape } from '../../../../shared/components/modal-form/modal-form-drawer-escape.util';
import { ModalFormHomeService } from './service/modal-form-home.service';

@Component({
  selector: 'app-modal-form-home',
  imports: [MatSidenavModule],
  templateUrl: './modal-form-home.component.html',
  styleUrl: './modal-form-home.component.scss',
})
export class ModalFormHomeComponent {
  private readonly modalFormHomeService = inject(ModalFormHomeService);
  @ViewChild('drawer') drawer: MatDrawer;

  constructor() {
    this.modalFormHomeService.openDrawerHome.subscribe(() => {
      this.drawer.open();
    });
    this.modalFormHomeService.closeDrawerHome.subscribe(() => {
      this.drawer.close();
    });
  }

  onClose() {
    this.modalFormHomeService.showingModalHome.next(false);
    this.modalFormHomeService.modalMode.next('enviar');
  }

  onBackdropClick() {
    this.modalFormHomeService.closeDrawerHome.next(true);
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (shouldDrawerCloseOnEscape(this.drawer?.opened)) {
      this.modalFormHomeService.closeDrawerHome.next(true);
    }
  }
}
